<template>
  <div class="hero is-primary section-service-list" id="section-service-list">
    <!-- <div class="hero-cover hero-cover-showcase">
    </div> -->
    <div class="hero-body" style="color:white;">
      <div class="container">
        <div class="columns is-multiline is-gapless is-centered">
          <div class="column is-10">
            <h1>$ &gt; services</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="hero-body" style="padding:0;margin-bottom:5em;">
      <div class="container">
        <div class="columns is-multiline is-gapless is-centered">
          <div class="column is-10">
            <div class="columns is-multiline is-gapless">
              <div class="column is-6 has-text-centered section-1" data-aos="fade-up" data-aos-once="true">
                <span>bespoke solutions</span>
              </div>
              <div class="column is-6 has-text-centered section-2" data-aos="fade-up" data-aos-once="true">
                <span>branding &amp; collateral design</span>
              </div>
            </div>
            <div class="columns is-multiline is-gapless">
              <div class="column is-6 has-text-centered section-3" data-aos="fade-up" data-aos-once="true">
                <span>responsive to modern platforms</span>
              </div>
              <div class="column is-6 has-text-centered section-4" data-aos="fade-up" data-aos-once="true">
                <span>mobile apps</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'section-service-list',
    components: {
    },
    data () {
      return {
        quoteContent: ''
      }
    },
    computed: {
      quoteContentUrl: function () {
        return 'https://twitter.com/intent/tweet?text=' + encodeURI(this.quoteContent)
      }
    },
    created () {
    },
    mounted () {
    },
    methods: {
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.section-service-list {
  transition: visibility 0s linear 0s,opacity .4s 0s;
  background-color: $color-gray;

  .columns.is-gapless:not(:last-child) {
    margin-bottom: 0;
  }

  .section-1, .section-2, .section-3, .section-4 {
    font-size: 0.9em;
    height: 60vw;
    @media screen and (min-width: $tablet) {
      height: 35vw;
    }
    @media screen and (min-width: $desktop) {
      height: 18.5vw;
    }
    background-size: cover;
  }

  .columns {
    margin-bottom: 0;
    .section-1 {
      background-image: url('../assets/showcase_lastingimpressions.png');
      position: relative;
      span {
        position: absolute;
        display: inline-block;
        color: black;
        right: 30px;
        bottom: 15px;
      }
    }

    .section-2 {
      background-image: url('../assets/showcase_komaneko.png');
      position: relative;
      span {
        position: absolute;
        display: inline-block;
        right: 30px;
        bottom: 15px;
      }
    }

    .section-3 {
      background-image: url('../assets/showcase_gap.png');
      position: relative;
      span {
        position: absolute;
        display: inline-block;
        color: black;
        right: 30px;
        bottom: 8px;
      }
    }

    .section-4 {
      background-image: url('../assets/showcase_keyg.png');
      position: relative;
      span {
        position: absolute;
        display: inline-block;
        right: 30px;
        bottom: 15px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// ContentServiceListSection.vue?6e323bc3